<template>
  <div class="headcontent">
    <div class="w1200 headbox">
      <p>
        彭氏宗亲，您好！欢迎您！
      </p>
      <p class="head_p">
        {{ times }}
      </p>
      <p class="span_p_nav">
        <a href="http://www.pengzushijia.com/" target="_blank" class="span_nav">平台导航</a>
        <a :href="getTokenUrl" target="_blank" class="span_nav" @click="changeurl">编纂平台</a>
        <a href="http://maker.pengzushijia.com/project/allDataBase" target="_blank" class="span_nav">总数据库</a>
        <!--<a href="http://admin.pengzushijia.com" target="_blank" class="span_nav">管理平台</a>-->
        <!--<span class="line_span" />-->
        <!--<a href="javascript:;" class="span_nav puyue">谱阅-->
        <!--<img :src="puyueCode" alt="" class="puyueCode">-->
        <!--</a>-->
        <!--<span class="line_span" />-->
        <!--<a href="/database" class="span_nav">国谱馆</a>-->
        <!--<span class="line_span" />-->
        <!--<a href="javascript:;" class="span_nav">根籍搜索</a>-->
        <!--<span class="line_span" />-->
        <!--<a href="javascript:;" class="span_nav fms">家族群空间-->
        <!--<img :src="fmsCode" alt="" class="fmsCode">-->
        <!--</a>-->
      </p>
      <div v-show="!islogin" class="login_register">
        <a href="/login">登录</a>
        <a href="/register">注册</a>
        <!--<a href="/login">注册</a>-->
      </div>
      <div v-show="islogin" style="display: inline-block;height: 40px;line-height: 40px;vertical-align: top">
        <div class="imgBox">
          <img v-if="userData.USER_PHOTO" :src="userData.USER_PHOTO" alt="">
          <img v-else :src="noIMG" alt="">
        </div>
      <!--&lt;!&ndash;<div class="usercontent">&ndash;&gt;-->
      <!--&lt;!&ndash;<el-tooltip class="item" effect="dark" :content="userData.USER_MOBILE" placement="top-start">&ndash;&gt;-->
      <!--&lt;!&ndash;<span v-if="userData.USER_NAME">{{ userData.USER_NAME }}</span>&ndash;&gt;-->
      <!--&lt;!&ndash;<span v-else>{{ userData.USER_MOBILE }}</span>&ndash;&gt;-->
      <!--&lt;!&ndash;<svg-icon icon-class="top" />&ndash;&gt;-->
      <!--&lt;!&ndash;</el-tooltip>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;<ul class="list">&ndash;&gt;-->
      <!--&lt;!&ndash;<li v-for="(item,index) in arrs" :key="index" @click="goUserMsg(index)">&ndash;&gt;-->
      <!--&lt;!&ndash;{{ item.name }}&ndash;&gt;-->
      <!--&lt;!&ndash;</li>&ndash;&gt;-->
      <!--&lt;!&ndash;</ul>&ndash;&gt;-->
      </div>
      <div v-show="islogin" class="mycenter">
        <span @click="gousercerter">我的个人中心</span>
      </div>
    </div>
    <div class="head_nav">
      <div class="navs">
        <div class="w1200">
          <div class="logoBox" :class="phoneChangeClass">
            <img :src="logo" alt="" style="cursor: pointer" @click="gohome">
            <!--<span style="margin-left: 20px">-->
            <!--<img :src="logo_new" alt="">-->
            <!--</span>-->
            <button type="button" class="navbar-toggle collapsed phoneHide" @click="phoneMenuControl">
              <span class="icon-bar icon-bar-1" />
              <span class="icon-bar icon-bar-2" />
              <span class="icon-bar icon-bar-3" />
            </button>
          </div>
          <!--<div class="topMsg">-->
          <!--<span>《中国姓氏大百科》</span>-->
          <!--<span>唯一指定官方网站</span>-->
          <!--</div>-->
          <div class="serchNew_newBox">
            <div class="serchNew">
              <span class="el-icon-search searchIcon" @click="goSearchgen" />
              <input v-model="searchKey" type="text" placeholder="请输入关键字搜索" @focus="focushandel" @blur="blurhandel">
              <span class="searchBtn">
                <!--<span class="btnSty btnSty2" @click="goSearch">站内搜索</span>-->
                <span class="btnSty" @click="goSearchgen">一键搜索</span>
              </span>
            </div>
            <div class="search_ul">
              <span @click="goSearch2('彭祖世家')">彭祖世家</span>
              <span class="line_span" />
              <span @click="goSearch2('彭祖')">彭祖</span>
              <span class="line_span" />
              <span @click="goSearch2('构云')">构云</span>
              <span class="line_span" />
              <span @click="goSearch2('家谱')">家谱</span>
              <span class="line_span" />
              <span @click="goSearch2('彭氏远祖世次')">彭氏远祖世次</span>
            </div>
          </div>
        </div>
        <div class="navbar-on-shadow" :class="phoneChangeClass" @click="phoneMenuControl" />
        <div class="navBox" :class="phoneChangeClass">
          <span class="closeRightBanner" @click="phoneMenuControl">
            X
          </span>
          <div class="shownavBox">
            <div class="tip phoneShow">
              彭氏宗亲,您好!欢迎您!
            </div>
            <div class="tip phoneShow">
              {{ times }}
            </div>
            <div class="phoneShow">
              <div class="searchPhone">
                <input v-model="searchKey" type="text" placeholder="请输入关键词搜索">
                <span class="el-icon-search searchIcon" @click="goSearch" />
              </div>
            </div>
            <div class="headul_box w1200">
              <ul class="head-ul">
                <li :class="currentIndex===0?'avtive':'noactive'" style="margin-left: 0;" @click="gonav(0)">
                  <router-link tag="a" :to="{name:'ho'}" class="navli">
                    首页
                  </router-link>
                </li>
                <li :class="currentIndex===1?'avtive':'noactive'" @click="gonav(1)">
                  <router-link tag="a" :to="{name:'ne',params:{templateId:'NEWS'}}" class="navli">
                    彭祖世家资讯
                  </router-link>
                </li>
                <li :class="currentIndex===2?'avtive':'noactive'" @click="gonav(2)">
                  <router-link tag="a" :to="{name:'at',params:{templateId:'PHOTO'}}" class="navli">
                    彭氏相册
                  </router-link>
                </li>
                <li :class="currentIndex===3?'avtive':'noactive'" @click="gonav(3)">
                  <router-link tag="a" :to="{name:'vd',params:{templateId:'VIDEO'}}" class="navli">
                    视频中心
                  </router-link>
                </li>
                <li :class="currentIndex===4?'avtive':'noactive'" @click="gonav(4)">
                  <router-link tag="a" :to="{name:'li',params:{templateId:'DOC'}}" class="navli">
                    资料文库
                  </router-link>
                </li>
                <li :class="currentIndex===5?'avtive':'noactive'" @click="gonav(5)">
                  <router-link tag="a" :to="{name:'Blist'}" class="navli">
                    彭氏家谱
                  </router-link>
                </li>
                <li :class="currentIndex===6?'avtive':'noactive'" @click="gonav(6)">
                  <router-link tag="a" :to="{name:'BWlist',}" class="navli">
                    谱牒文摘
                  </router-link>
                </li>
                <li :class="currentIndex===7?'avtive':'noactive'" @click="gonav(7)">
                  <router-link tag="a" :to="{name:'Trlist'}" class="navli">
                    宗支世系
                  </router-link>
                </li>
                <li :class="currentIndex===8?'avtive':'noactive'" @click="gonav(8)">
                  <router-link tag="a" :to="{name:'Nlist'}" class="navli">
                    先祖人物
                  </router-link>
                </li>
                <!--<li :class="currentIndex===9?'avtive':'noactive'" @click="gonav(9)">-->
                <!--<router-link tag="a" :to="{name:'datab'}" class="navli">-->
                <!--国谱馆-->
                <!--</router-link>-->
                <!--&lt;!&ndash;<a href="/database" class="navli">国谱馆</a>&ndash;&gt;-->
                <!--</li>-->
                <li :class="currentIndex===11?'avtive':'noactive'" @click="gonav(11)">
                  <router-link tag="a" :to="{name:'al'}" class="navli">
                    专辑网刊
                  </router-link>
                </li>
                <li :class="currentIndex===12?'avtive':'noactive'" @click="gonav(12)">
                  <router-link tag="a" :to="{name:'sp'}" class="navli">
                    彭氏各地
                  </router-link>
                </li>
                <!--<li :class="currentIndex===13?'avtive':'noactive'">-->
                <!--<a href="http://ecs.chinagen.cn" target="_blank" class="navli">中国姓氏大百科</a>-->
                <!--</li>-->
              </ul>
            </div>
            <div v-if="!islogin" class="footBox">
              <a href="/login" style="float: left">登录</a>
              <a href="/register" style="float: right">注册</a>
            </div>
            <div v-if="islogin" class="userMsg">
              <div class="imgBox">
                <img v-if="userData.USER_PHOTO" :src="userData.USER_PHOTO" alt="">
              </div>
              <span class="username_span">{{ userData.USER_NICK_NAME }}</span>
              <span class="username_span"><a href="">我的个人中心</a></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInitMsg, userOutLogin } from '@/api/api.js'
import { ssoUserLogin } from '@/api/api.js'
import { addLoginState } from '@/api/login.js'
export default {
  inject: ['reload'],
  name: 'Header',
  data() {
    return {
      getTokenUrl: '',
      allowGo: false,
      logo_new: require('@/static/ecsLogo.png'),
      puyueCode: require('@/static/readerCode.png'),
      fmsCode: require('@/static/familyspaceCode.png'),
      phoneChangeClass: '',
      times: '',
      searchKey: '',
      logo: require('@/static/cmslogo.png'),
      currentIndex: null,
      islogin: false,
      username: '',
      userData: {},
      noIMG: require('@/static/usuerDefault.png'),
      jiantou: require('@/static/jiantouchinaGen.png'),
      arrs: [{ 'name': '账号设置' }, { 'name': '我的收藏' }, { 'name': '我的评论' }, { 'name': '我的消息' }, { 'name': '退出登录' }]
    }
  },
  watch: {
    $route(to, from) {
      ssoUserLogin().then(res => {
        if (res.data.userId) {
          this.setloca('userid', res.data.userId, 7200)
          localStorage.removeItem('unionid')
          this.cheackLogin(res.data.userId)
        } else {
          localStorage.removeItem('userid')
          localStorage.removeItem('unionid')
          this.islogin = false
        }
      })
      // this.canSearch = false
      if (this.$route.query.index || this.$route.query.index == '0') {
        this.currentIndex = this.$route.query.index
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.changeurl()
    }, 1000)
    // //input数据显示
    if (this.$route.path === '/allDataSearch') {
      this.searchKey = this.$route.query.searchName
    }

    // //回车搜索事件
    const that = this
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which
      if (keycode == 13 && that.allowGo) {
        that.goSearchgen()
        return false
      }
    }
    // console.log(this.$route.name)
    if (this.$route.name == 'ho') {
      this.currentIndex = 0
    }
    if (this.$route.name == 'ne') {
      this.currentIndex = 1
    }
    if (this.$route.name == 'at') {
      this.currentIndex = 2
    }
    if (this.$route.name == 'vd') {
      this.currentIndex = 3
    }
    if (this.$route.name == 'li') {
      this.currentIndex = 4
    }
    if (this.$route.name == 'Blist') {
      this.currentIndex = 5
    }
    if (this.$route.name == 'BWlist') {
      this.currentIndex = 6
    }
    if (this.$route.name == 'Trlist') {
      this.currentIndex = 7
    }
    if (this.$route.name == 'Nlist') {
      this.currentIndex = 8
    }
    if (this.$route.name == 'datab') {
      this.currentIndex = 9
    }
    if (this.$route.name == 'al') {
      this.currentIndex = 10
    }
    if (this.$route.name == 'sp') {
      this.currentIndex = 11
    }
    this.getTimes()
    // 单点登录请求
    ssoUserLogin().then(res => {
      if (res.data.userId) {
        this.setloca('userid', res.data.userId, 7200)
        this.cheackLogin(res.data.userId)
      } else {
        localStorage.removeItem('userid')
        localStorage.removeItem('unionid')
        this.islogin = false
      }
    })
  },
  methods: {
    changeurl(url) {
      url = 'http://maker.pengzushijia.com/ssoLogin/ssoLogin?token='
      // url = 'http://maker.myfamilybook.cn/ssoLogin/ssoLogin?token='
      if (this.getLoca('userid')) {
        addLoginState({ unionid: this.getLoca('unionid') }).then(res => {
          if (res.data.errcode === '0') {
            var nurl = url + res.data.token
            this.getTokenUrl = nurl
          }
          if (res.data.errcode == '1') {
            this.$alert('您的登录信息已经过期，请重新登录', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push('/login')
              }
            })
          }
        })
      } else {
        this.getTokenUrl = 'http://maker.pengzushijia.com'
      }
    },
    cheackLogin(id) {
      if (id) {
        getInitMsg({ 'userId': id }).then(res => {
          this.setloca('unionid', res.data.UNIONID, 7200)
          this.setloca('readerUsrId', res.data.readerUsrId, 7200)
          // unionid
          this.userData = res.data
          if (!this.userData.USER_PHOTO && this.userData.wxUserData) {
            this.userData.USER_PHOTO = this.userData.wxUserData.headImgUrl
          }
          if (!this.userData.USER_NAME && this.userData.wxUserData) {
            this.userData.USER_NAME = this.userData.wxUserData.nickName
          }
          this.islogin = true
        })
      } else {
        this.islogin = false
      }
    },
    goUserMsg: function(index) {
      this.phoneMenuControl()
      this.fn()
      if (typeof (index) === 'number') {
        if (index === 4) {
          this.islogin = false
          localStorage.removeItem('username')
          localStorage.removeItem('userid')
          userOutLogin().then(res => {

          })
          this.$message({
            showClose: true,
            message: '您已成功退出登录',
            type: 'success'
          })
          this.$router.push({ path: '/home' })
        } else {
          this.$router.push({ path: '/user', query: { index: index }})
        }
      }
    },
    gonav: function(index) {
      this.phoneMenuControl()
      this.fn()
      this.currentIndex = index
    },
    goSearch2: function(key) {
      const { href } = this.$router.resolve({
        path: '/allDataSearch',
        name: 'asv',
        query: {
          'searchName': key
        }
      })
      window.open(href, '_blank')
    },
    gousercerter() {
      ssoUserLogin().then(res => {
        if (res.data.userId) {
          this.setloca('userid', res.data.userId, 7200)
          localStorage.removeItem('unionid')
          if (res.data.userId) {
            const { href } = this.$router.resolve({
              path: '/user',
              name: 'um',
              query: {
                'index': 0
              }
            })
            window.open(href, '_blank')
          }
        } else {
          localStorage.removeItem('userid')
          localStorage.removeItem('unionid')
          this.reload()
        }
      })
    },
    goSearch: function() {
      this.phoneMenuControl()
      this.fn()
      if (this.searchKey) {
        const { href } = this.$router.resolve({
          path: '/search',
          name: 'search',
          query: {
            'searchName': this.searchKey
          }
        })
        window.open(href, '_blank')
      } else {
        this.$message({
          message: '请输入关键字',
          type: 'warning',
          duration: 1500
        })
      }
    },
    goSearchgen() {
      const { href } = this.$router.resolve({
        path: '/allDataSearch',
        name: 'asv',
        query: {
          'searchName': this.searchKey
        }
      })
      // /当前页面不新开页局部刷新
      if (this.$route.path === '/allDataSearch') {
        this.$router.replace({ path: '/allDataSearch', query: { searchName: this.searchKey }})
      } else {
        this.searchKey = ''
        window.open(href, '_blank')
      }
    },
    gohome: function() {
      this.fn()
      this.$router.push({ path: '/home' })
    },
    getTimes() {
      var sWeek = new Array('星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六')
      var dNow = new Date()
      var CalendarData = new Array(100); var madd = new Array(12); var tgString = '甲乙丙丁戊己庚辛壬癸'; var dzString = '子丑寅卯辰巳午未申酉戌亥'; var numString = '一二三四五六七八九十'; var monString = '正二三四五六七八九十冬腊'; var weekString = '日一二三四五六'; var sx = '鼠牛虎兔龙蛇马羊猴鸡狗猪'; var cYear, cMonth, cDay, TheDate
      CalendarData = new Array(0xA4B, 0x5164B, 0x6A5, 0x6D4, 0x415B5, 0x2B6, 0x957, 0x2092F, 0x497, 0x60C96, 0xD4A, 0xEA5, 0x50DA9, 0x5AD, 0x2B6, 0x3126E, 0x92E, 0x7192D, 0xC95, 0xD4A, 0x61B4A, 0xB55, 0x56A, 0x4155B, 0x25D, 0x92D, 0x2192B, 0xA95, 0x71695, 0x6CA, 0xB55, 0x50AB5, 0x4DA, 0xA5B, 0x30A57, 0x52B, 0x8152A, 0xE95, 0x6AA, 0x615AA, 0xAB5, 0x4B6, 0x414AE, 0xA57, 0x526, 0x31D26, 0xD95, 0x70B55, 0x56A, 0x96D, 0x5095D, 0x4AD, 0xA4D, 0x41A4D, 0xD25, 0x81AA5, 0xB54, 0xB6A, 0x612DA, 0x95B,
        0x49B, 0x41497, 0xA4B, 0xA164B, 0x6A5, 0x6D4, 0x615B4, 0xAB6, 0x957, 0x5092F,
        0x497, 0x64B, 0x30D4A, 0xEA5, 0x80D65, 0x5AC, 0xAB6, 0x5126D, 0x92E, 0xC96, 0x41A95, 0xD4A, 0xDA5, 0x20B55, 0x56A, 0x7155B, 0x25D, 0x92D, 0x5192B, 0xA95, 0xB4A, 0x416AA, 0xAD5, 0x90AB5, 0x4BA, 0xA5B, 0x60A57, 0x52B, 0xA93, 0x40E95)
      madd[0] = 0; madd[1] = 31; madd[2] = 59; madd[3] = 90
      madd[4] = 120; madd[5] = 151; madd[6] = 181; madd[7] = 212
      madd[8] = 243; madd[9] = 273; madd[10] = 304; madd[11] = 334
      function GetBit(m, n) { return (m >> n) & 1 }
      function e2c() {
        TheDate = (arguments.length != 3) ? new Date() : new Date(arguments[0], arguments[1], arguments[2])
        var total, m, n, k
        var isEnd = false
        var tmp = TheDate.getFullYear()
        total = (tmp - 1921) * 365 + Math.floor((tmp - 1921) / 4) + madd[TheDate.getMonth()] + TheDate.getDate() - 38; if (TheDate.getYear() % 4 == 0 && TheDate.getMonth() > 1) { total++ } for (m = 0; ; m++) { k = (CalendarData[m] < 0xfff) ? 11 : 12; for (n = k; n >= 0; n--) { if (total <= 29 + GetBit(CalendarData[m], n)) { isEnd = true; break } total = total - 29 - GetBit(CalendarData[m], n) } if (isEnd) break } cYear = 1921 + m; cMonth = k - n + 1; cDay = total; if (k == 12) { if (cMonth == Math.floor(CalendarData[m] / 0x10000) + 1) { cMonth = 1 - cMonth } if (cMonth > Math.floor(CalendarData[m] / 0x10000) + 1) { cMonth-- } }
      }
      function GetcDateString() {
        var tmp = ''; tmp += tgString.charAt((cYear - 4) % 10)
        tmp += dzString.charAt((cYear - 4) % 12)
        tmp += '年 '
        if (cMonth < 1) { tmp += '(闰)'; tmp += monString.charAt(-cMonth - 1) } else { tmp += monString.charAt(cMonth - 1) } tmp += '月'; tmp += (cDay < 11) ? '初' : ((cDay < 20) ? '十' : ((cDay < 30) ? '廿' : '三十'))
        if (cDay % 10 != 0 || cDay == 10) { tmp += numString.charAt((cDay - 1) % 10) } return tmp
      }
      function GetLunarDay(solarYear, solarMonth, solarDay) {
        if (solarYear < 1921 || solarYear > 2020) {
          return ''
        } else { solarMonth = (parseInt(solarMonth) > 0) ? (solarMonth - 1) : 11; e2c(solarYear, solarMonth, solarDay); return GetcDateString() }
      }
      var D = new Date()
      var yy = D.getFullYear()
      var mm = D.getMonth() + 1
      var dd = D.getDate()
      var ww = D.getDay()
      var ss = parseInt(D.getTime() / 1000)
      function getFullYear(d) { // 修正firefox下year错误
        var yr = d.getYear()
        if (yr < 1000) { yr += 1900 } return yr
      }
      function showDate() {
        var sValue = getFullYear(dNow) + '年' + (dNow.getMonth() + 1) + '月' + dNow.getDate() + '日' + ' ' + sWeek[dNow.getDay()] + ' '
        sValue += GetLunarDay(yy, mm, dd)
        return sValue
      }
      this.times = showDate()
    },
    /* 手机端菜单操作*/
    phoneMenuControl() {
      if (this.phoneChangeClass == '') {
        this.phoneChangeClass = 'navbar-on'
      } else {
        this.phoneChangeClass = ''
      }
    },
    fn: function() {
      window.scrollTo(0, 0)
    },
    focushandel() {
      this.allowGo = true
    },
    blurhandel() {
      this.allowGo = false
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .btnSty{
    color: #ffffff;
    cursor: pointer;
    background-color: #7E6B5A;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    vertical-align: top;
  }
  .btnSty2{
    background-color: #999;
  }
  .imgBox{
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    margin-top: 5px;
    img{
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
  .mycenter{
    display: inline-block;
    height: 25px;
    border: 1px solid #7E6B5A;
    line-height: 25px;
    padding: 0 10px;
    float: right;
    margin-right: 11px;
    margin-top: 7px;
    span{
      color: #7E6B5A;
      cursor: pointer;
    }
  }
  .puyue{
    position: relative;
  }
  .fms{
    position: relative;
  }
  .fmsCode{
    width: 179px;
    /*height: 213px;*/
    position: absolute;
    top: 16px;
    left: -48px;
    z-index: 99;
    transition: 0.3s;
    height: 0;
  }
  .puyueCode{
    width: 179px;
    /*height: 213px;*/
    position: absolute;
    top: 16px;
    left: -67px;
    z-index: 99;
    transition: 0.3s;
    height: 0;
  }
  .puyue:hover >.puyueCode{
    height: 213px;
  }
  .fms:hover >.fmsCode{
    height: 213px;
  }
  .shownavBox{
    height: 50px;
    background-color: #7E6B5A;
    overflow: hidden;
    margin-top: 47px;
    border-top: 1px solid #EEEEEE;
    /*box-shadow: 5px 5px 5px 5px hsla(0,0%,72%,.7);*/
  }
  .headul_box{
  position: relative;
    height: 50px;
    background-color: #7E6B5A;
  }
  .gomfb{
    position: absolute;
    right: 0px;
    top: 14px;
    height: 20px;
    font-size: 16px;
  }
  .gomfb span{
    font-size: 16px;
    color: #E3003A;
  }
  .serchNew_newBox{
    vertical-align: top;
    height: 68px;
    width: 524px;
    background-color: #fff;
    display: inline-block;
    margin-top: 1px;
    float: right;
    margin-right: 7px;
    .search_ul{
      width: 520px;
      display: inline-block;
      height: 30px;
      line-height: 30px;
      span{
        color: #A9A9A9;
        cursor: pointer;
        &:hover{
          color: #E3003A;
        }
      }
      .line_span{
        margin: 0 8px;
        color: #A9A9A9;
      }
    }
  }
  .serchNew{
    vertical-align: top;
    height: 38px;
    width: 520px;
    border: 1px solid #7E6B5A;
    display: inline-block;
    position: relative;
    .searchIcon{
      cursor: pointer;
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      height: 38px;
      width: 65px;
      text-align: center;
      line-height: 38px;
      color: #7E6B5A;
      vertical-align: top;
      font-size: 20px;
    }
    input{
      height: 38px;
      width: 330px;
      position: absolute;
      left: 65px;
      top: 0;
    }
    .searchBtn{
      display: inline-block;
      position: absolute;
      right: 0;
      top: -1px;
      width: 120px;
      height: 39px;
      text-align: center;
      line-height: 39px;
      color: #ffffff;
    }
  }
  .topMsg{
    margin-top: 8px;
    margin-left: 25px;
    width: 130px;
    height: 35px;
    background-color: #E3003A;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    padding: 10px 8px;
    display: inline-block;
    vertical-align: top;
    border-radius: 5px;
  }
  .searchBox{
    display: inline-block;
    height: 38px;
    line-height: 30px;
    margin-left: 120px;
    position: absolute;
    right: 12px;
    top: 10px;
    border: 1px solid #CCBDAF;
    padding:0 8px;
    z-index: 8;
    background-color: #fff;
    input{
      width: 0;
      height: 20px;
      background-color: #ffffff;
      vertical-align: middle;
      overflow: hidden;
      transition: 1s;
    }
    span{
      font-size: 18px;
      cursor: pointer;
      color: #7E6B5A;
    }
  }
  .searchBox:hover >input{
    width: 195px;
    /*float: left;*/
    text-indent: 15px;
  }
  .span_p_nav{
    margin-left: 320px;
  }
  .line_span{
    width: 2px;
    height: 14px;
    background-color: #eeeeee;
    display: inline-block;
    vertical-align: -0.1rem;
  }
  .span_nav{
    color: #666;
    font-size: 14px;
    padding:0 12px;
    cursor: pointer;
    &:hover{
      color: #7E6B5A;
    }
  }
  .outHome,.outHome:hover{
    color: #bb9a51;
    margin-right: 20px;
  }
    ///头部样式
    .headcontent{
      background-color: #F0F0F0;
      width: 100%;
      height: 250px;
      position: relative;
      .head_nav{
        width: 100%;
        height: 170px;
        background-color: #fff;
        padding-top: 40px;
        margin-bottom: 3px;
        /*box-shadow: 0 0px 5px 0px hsla(0,0%,72%,.5);*/
        .navs{
          height: 72px;
          position: relative;
          .logoBox{
            /*width: 223px;*/
            height: 72px;
            font-size: 0;
            display: inline-block;
            vertical-align: top;
            img{
              width: auto;
              height: 72px;
            }
          }
          .navBox{
            /*display: inline-block;*/
            /*height: 60px;*/
            /*height: 49px;*/
              .w1200{
                  overflow: hidden;
              }
          }
        }
      }
    }
    .headbox{
        height: 40px;
        padding: 0;
        line-height: 40px;
        position: relative;
       background-color: #F0F0F0;
      p{
        display: inline-block;
        font-size: 14px;
        color:#666666;
        vertical-align: top;
      }
      .head_p{
        color:#bb9a51;
        margin-left: 45px;
      }
    }
    .logo-box{
        float: left;
    }
.logo-img{
    width: 100px;
    height: 33px;
    vertical-align: middle;
  cursor: pointer;
}
.head-ul{
    display: inline-block;
    overflow: hidden;
    height: 49px;
    li{
        display: inline-block;
      border-top: 2px solid transparent;
      margin-top: 13px;
      margin-left: 10px;
      margin-right: 10px;
      /*&:hover{*/
        /*border-top: 2px solid #ed4040;*/
      /*}*/
      a{
        padding: 7px 8px;
        margin: 0 2px;
        cursor: pointer;
        color: #fff;
        font-size: 16px;
      }
    }
}
    //搜索样式
    ///登录注册样式
    .login_register{
        float: right;
        width: 88px;
        height: 28px;
        margin-top: 5px;
        line-height: 28px;
        a{
            display: inline-block;
            width: 42px;
            text-align: center;
            height: 16px;
            margin-top: 6px;
            font-size: 14px;
            line-height: 16px;
            color: #666;
          &:hover{
            color: #7E6B5A;
          }
        }
    }
    .userBox {
      border-radius: 5px;
      width: 90px;
      height: 30px;
      margin: 5px 20px;
      line-height: 30px;
      transition: 0.5s;
      position:absolute;
      z-index: 10;
      right: 2px;
      top: 0px;
      overflow: hidden;
      &:hover{
        height:320px;
      }
      .imgBox{
        height: 30px;
        display: inline-block;
        vertical-align: top;
        font-size: 0;
        border: 1px solid #ffffff;
      }
      .usercontent{
        width: 60px;
        display: inline-block;
        height: 30px;
        font-size: 12px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        margin-left: 5px;
        cursor: pointer;
        position: absolute;
        z-index: 6;
      }
    }
    .login_register a:nth-of-type(1){
        border-right: 1px solid #7E6B5A;
    }
  .list{
    margin-top: 10px;
    background-color: #fff;
    li{
      width: 90px;
      text-align: center;
      height: 36px;
      line-height: 36px;
      font-size: 12px;
      cursor: pointer;
      margin-top: 0;
      &:hover{
        background-color: #ed4040;
      }
    }
  }
    .head-ul{
      .avtive{
        .navli{
          border-bottom: 2px solid #fff;
        }
      }
    }
  .navbar-on-shadow,.phoneTips,.phoneMenus,.phoneUsers{
    display: none;
  }
  .phoneShow{
    display: none;
  }
  .closeRightBanner{
    display: none;
  }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
@media screen and (max-width: 750px){
  .outHome,.outHome:hover{
    color: #fff;
  }
  .headcontent{
    height: 50px;
    position: relative;
    z-index: 99;
    .headbox{
      display: none;
    }
    .head_nav{
      height: 50px;
      padding-top: 0;
      margin-bottom: 3px;
      /*box-shadow: 0 0px 5px 0px hsla(0,0%,72%,.5);*/
      .navs{
        height: 50px;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(255,255,255,.8);
        width: 100%;
        z-index: 999;
        overflow: visible;
        .logoBox{
          width: 100%;
          box-sizing: border-box;
          height: 50px;
          line-height: 50px;
          padding:10px;
          position: relative;
          img{
            height: 30px;
            width: auto;
          }
        }
        .navbar-on{
          .icon-bar {
            transition: all .3s ease-out .3s;
            background: #fff !important
          }
          .icon-bar-1 {
            margin-bottom: 0;
            -webkit-transform: rotate(-45deg) translate(-3px, 5px);
            transform: rotate(-45deg) translate(-3px, 5px)
          }
          .icon-bar-2 {
            opacity: 0
          }
          .icon-bar-3 {
            -webkit-transform: rotate(45deg) translate(-3px, -5px);
            transform: rotate(45deg) translate(-3px, -5px)
          }
        }
        .navbar-toggle {
          display: block;
          margin:0;
          transition: all .3s ease-out 0s;
          float: right;
          padding: 9px 10px;
          background-color: transparent;
          background-image: none;
          border: 1px solid transparent;
          border-radius: 4px;
          position: relative;
          top: -5px;
          .icon-bar {
            display: block;
            width: 22px;
            height: 2px;
            border-radius: 1px;
            transition: all .3s ease-out .3s;
            background: #999;
            margin-top: 4px;
          }
        }
        /*菜单栏*/
        .navBox.navbar-on{
          left: 0;
        }
        .navBox{
          position: fixed;
          top: 0;
          left: -80%;
          width: 80%;
          height: 100%;
          background: #e3003a;
          z-index: 100;
          overflow: auto;
          transition: left .3s ease-out 0s;
        }
        .head-ul{
          margin: 0;
          height: auto;
          width: 100% ;
          li:hover,.avtive:hover{
            background: #fff;
            a{
              color: #e3003a;
            }
          }
          li{
            width: auto;
            display: block;
            padding: 10px 10px;
            margin:0 20px;
            a{
              font-size: 16px;
              color: #fff;
              display: inline-block;
            }
          }
          .avtive .navli{
            color: #fff;
            /*font-weight: bold;*/
          }
        }
        .phoneTips.navbar-on,.phoneMenus.navbar-on{
          display: block;
        }
        .phoneTips{
          line-height: 25px;
          padding: 10px;
          color: #fff;
          position: relative;
          .closeRightBanner{
            position: absolute;
            top: 10px;
            right: 10px;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            /*font-weight: bold;*/
            svg{
              font-size: 22px;
            }
          }
          .searchBox{
            background: #fff;
            height: 40px;
            line-height: 40px;
            margin-top: 10px;
            position: relative;
            input{
              text-indent: 15px;
            }
            span{
              background: #e3003a;
              display: inline-block;
              box-sizing: border-box;
              height: 40px;
              line-height: 40px;
              padding: 0 15px;
              position: absolute;
              right: 0;
              top: 0;
              border: 1px solid #fff;
            }
          }
        }
        .phoneMenus{
          border-top: 2px solid #fff;
          padding: 10px;
          a{
            display: inline-block;
            width: 50%;
            text-align: center;
            color: #fff;
            font-size: 14px;
            line-height: 36px;
          }
        }
        .phoneUsers{
          border-top: 2px solid #fff;
          padding: 10px;
          position: relative;
          display: block;
          .login_register{
            color: #fff;
            width: auto;
            text-align: right;
            position: relative;
            float: none;
            a{
              font-size: 14px;
              display: inline-block;
              padding: 3px 5px;
              background: #fff;
              border-radius: 3px;
              color: #e3003a;
             margin-left: 10px;
            }
          }
          .userBox{
            float: none;
            position: relative;
            width: auto;
            height: auto;
            .usercontent{
              width: 200px;
            }
            .list{
              background: transparent;
              li{
                width: 50%;
                display: inline-block;
                background: transparent;
                color: #fff;
              }
            }
          }
        }
      }

    }
  }
  .navbar-on-shadow.navbar-on{
    display: block;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.7);
  }
  .headul_box{
    height: auto;
    background-color: #e3003a;
  }
  .head-ul .avtive{
    background:hsla(0,0%,100%,.3);
  }
  .head-ul .avtive .navli{
    border: none;
    margin:0 0px!important;
    width: 100%;
  }
  .head-ul li{
    margin:0 0px!important;
    padding: 10px 20px!important;
  }
  .head-ul li a{
    padding: 0;
    width: 100%;
  }
  .shownavBox{
    margin-top: 0;
    height: auto;
    .tip{
      color: #ffffff;
      background-color: #e3003a;
      height: 30px;
      line-height: 30px;
      padding: 0 20px;
      font-size: 13px;
    }
  }
  .serchNew_newBox{
    display: none;
  }
    .phoneShow{
      display: block;
      .searchBtn{
        background-color: #ffffff;
      }
  }
  .search_ul{
    background-color: #fff;
    padding: 0 10px;
    span{
      color: #ccc;
    }
    .line_span{
     border-color: #333;
      margin: 0 5px;
    }
  }
  .searchPhone{
    background-color: #E3003A;
    padding: 20px 20px;
    position: relative;
    text-align: center;
    input{
      width: 100%;
      height: 26px;
      padding: 5px 0;
      background: #fff;
      border: 1px solid #fff;
      text-indent: 5px;
    }
    .searchIcon{
      position: absolute;
      right: 22px;
      top: 29px;
      font-size: 20px;
    }
  }
  .footBox{
    background-color: #E3003A;
    height: 40px;
    padding: 20px;
    a{
      display: inline-block;
      height: 40px;
      background-color: #fff;
      width: 40%;
      line-height: 40px;
      color:#E3003A;
      vertical-align: top;
      text-align: center;
    }
  }
  .userMsg{
    background-color: #E3003A;
    height: 40px;
    padding: 20px;
    .username_span{
      color: #ffffff;
      display: inline-block;
      vertical-align: top;
      height: 40px;
      line-height: 40px;
      margin-left: 10px;
      font-size: 16px;
      max-width: 130px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      a{
        padding: 3px 5px;
        color: #ffffff;
        border: 1px solid #ffffff;
      }
    }
  }
  .closeRightBanner{
    position: absolute;
    top: 6px;
    right: 10px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    /*font-weight: bold;*/
    font-size: 24px;
    color: #ffffff;
    display: inline-block;
  }
}
</style>
